/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {WinPresentationController} from "../../WinPresentationController";
import {gsap, TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BelowStakeWinRestriction} from "../../../server/BelowStakeWinRestriction";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadGameConfig} from "../../../DevilsCrossRoadGameConfig";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";
import {DevilsCrossRoadGameMode} from "../../../server/DevilsCrossRoadGameMode";

export class BigWinController extends WinPresentationController {

    private _levelTimeline: TimelineLite | null;
    private _currentLevelSound: string;

    constructor() {
        super("BigWinController", true);
    }

    protected hasWin(): boolean {
        return DevilsCrossRoad.model.gameData.nextMode === GameMode.NORMAL &&
            DevilsCrossRoad.model.gameData.accumulatedRoundWin > 0 &&
            DevilsCrossRoad.model.totalWinRatioConfig!.bigWinLevel > -1;
    }

    protected async createWinAnimation(): Promise<any> {
        await new Promise<any>(resolve => {
            this.playBigWinLevel(0, resolve);
        });
    }

    private playBigWinLevel(level: number, resolve: (value: any) => void): void {
        const totalWinRatioConfig = DevilsCrossRoad.model.totalWinRatioConfig;
        const data = DevilsCrossRoad.model.gameData;
        if (level > totalWinRatioConfig!.bigWinLevel) {
            this._levelTimeline = null;
            this.playEnding(totalWinRatioConfig!.bigWinLevel, resolve);
        } else {
            const isEndLevel = level === totalWinRatioConfig!.bigWinLevel;
            const currentRatio = DevilsCrossRoadGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === level)!;
            const from: number = level === 0 ? 0 : data.playedBetValue * currentRatio.ratio;
            let  to: number = isEndLevel ? data.accumulatedRoundWin : data.playedBetValue * DevilsCrossRoadGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === (level + 1))!.ratio;
            const tooSmallEndLevel: boolean = isEndLevel && this.isLevelWinTooSmall(level, from, to);
            const tl = gsap.timeline();

            if (level < 4 && !tooSmallEndLevel) {
                const nextLevel: number = JSON.parse(JSON.stringify(level)) + 1;
                const isCurrentMaxLevel: boolean = nextLevel >= totalWinRatioConfig!.bigWinLevel;
                const nextRatio = DevilsCrossRoadGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === nextLevel)!;
                const isNextTooSmallWinLevel: boolean = this.isLevelWinTooSmall(nextLevel, data.playedBetValue * nextRatio.ratio, data.accumulatedRoundWin);
                if (isCurrentMaxLevel && isNextTooSmallWinLevel) {
                    to = data.accumulatedRoundWin;
                }
            }
            tl.add(this.getLevelAnimation(level, currentRatio.duration, from, to, isEndLevel));
            tl.add(() => this.playBigWinLevel(level + 1, resolve));
            this._levelTimeline = tl;
            if (tooSmallEndLevel) {
                this._levelTimeline.progress(1);
            } else {
                this._flowStateController.setSkipCallback(() => this.skip!());
            }
        }
    }

    private isLevelWinTooSmall(level: number, from: number, to: number): boolean {
        if (level === 0) {
            return false;
        }

        return (to - from) <= (from * 0.1);
    }

    private getLevelAnimation(level: number, duration: number, from: number, to: number, isEndLevel: boolean): TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            () => {
                DevilsCrossRoad.bigWinCountUp.scale.set(1.2);
                this._currentLevelSound = DevilsCrossRoadSound.BIG_WIN_MUSICS[level];
                DevilsCrossRoadSound.soundPlayer.playTrack({name: this._currentLevelSound});
            },
            DevilsCrossRoad.bigWinCountUp.getCountUpAnimation(from, to, duration, isEndLevel),
            gsap.to(DevilsCrossRoad.bigWinCountUp.scale, {duration: 0.5, x: 1, y: 1, ease: `power4.out`}),
            DevilsCrossRoad.bigwinView.getLevelAnimation(level, duration, isEndLevel)
        ]);
        return tl
    }

    protected skip() {
        DevilsCrossRoadSound.soundPlayer.stopTrack(this._currentLevelSound);
        if (this._levelTimeline && this._levelTimeline.isActive()) {
            this._levelTimeline.progress(1);
        }
    }

    private playEnding(endLevel: number, resolve: (value: any) => void): void {
        this._flowStateController.setSkipCallback();
        DevilsCrossRoadSound.soundPlayer.stopTrack(this._currentLevelSound);
        this._currentLevelSound = "";
        if(DevilsCrossRoad.model.data.mode!==DevilsCrossRoadGameMode.SUPER_FREESPIN && DevilsCrossRoad.model.data.mode!==DevilsCrossRoadGameMode.FREESPIN){
            if(!DevilsCrossRoad.model.gameData.brokeTheBank){
                DevilsCrossRoad.bigWinCountUp.stay();
                DevilsCrossRoad.bigwinView.playEnding(endLevel);
                DevilsCrossRoadSound.fadeMusic(1, 200);
            }else{
                DevilsCrossRoad.bigWinCountUp.hideCountup();
            }
        }else{
            if(!DevilsCrossRoad.model.gameData.brokeTheBank) {
                DevilsCrossRoad.bigWinCountUp.hideCountup();
                DevilsCrossRoad.bigwinView.playEnding(endLevel);
            }else{
                DevilsCrossRoad.bigWinCountUp.hideCountup();
            }
        }
        // DevilsCrossRoad.waysWon.stay();
        if(!DevilsCrossRoad.model.brokeTheBank){
            SlotGame.keypadPlugin.setWin(DevilsCrossRoad.model.data.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());
        }
        resolve(this);
    }
}